import { IS_PHONE_BROWSER, X_PAGE_ID } from 'reactApp/appHelpers/configHelpers';
import {
    isShowAiTooltipOnMediaFilesFeature,
    maxCountShowAiTooltipOnMediaFiles,
    showIntervalTooltip,
    storageKeyForTooltips,
} from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoImproving';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { safetyPersonalLocalStorage } from 'reactApp/storage';
import { store as reduxStore } from 'reactApp/store';

interface TooltipsData {
    shows?: string[];
    time?: number;
}

/** Возвращает данные о показах иконок с тултипом */
const getTooltipDataFromStorage: () => TooltipsData = () => {
    try {
        return JSON.parse(safetyPersonalLocalStorage.getItem(storageKeyForTooltips) || '{}');
    } catch {
        return {};
    }
};

/**
 * Можем ли показывать иконки с тултипами?
 */
export const getIsCanShowAiTooltipOnMediaFiles = () => {
    if (!isShowAiTooltipOnMediaFilesFeature) {
        return false;
    }

    // Получаем данные о прошлых показах
    const storageData = getTooltipDataFromStorage();

    // Текущее количество показов
    const countShow = storageData?.shows?.length || 0;
    // Время последнего показа
    const lastShowTime = storageData?.time || 0;

    const state = reduxStore.getState();
    const isBizUser = UserSelectors.isBizUser(state);
    const isPaidUser = UserSelectors.isPaidUser(state);
    const isOverquota = UserQuotaSelectors.isOverquota(state);
    const isCorp = UserSelectors.isCorpUser(state);
    const storage = getCurrentStorage(state);
    const currentTime = Math.floor(new Date().getTime() / 1000);
    // Прошло ли достаточное количество времени для показа?
    const isCanShowByTime = currentTime - showIntervalTooltip > lastShowTime;
    // Показывали ли тултипы в рамках текущей сессии?
    const isShowInCurrentSession = storageData?.shows?.includes(X_PAGE_ID);

    // Можем ли показать иконки с тултипами?
    const isCanShowAiTooltip =
        // Десктоп
        (!IS_PHONE_BROWSER &&
            // Прошло достатоное количество времени с прошлого показа
            (isCanShowByTime || isShowInCurrentSession) &&
            // Не достигли лимита по показам
            (countShow < maxCountShowAiTooltipOnMediaFiles || isShowInCurrentSession) &&
            // Не биз
            !isBizUser &&
            // Не платник
            !isPaidUser &&
            // Не корп
            !isCorp &&
            // Не оверквотер
            !isOverquota &&
            // Находимся в галерее или хомяке
            (storage === EStorageType.home || storage === EStorageType.gallery || storage === EStorageType.feed)) ||
        // Показывали в рамках этой сессии
        isShowInCurrentSession;

    const newData: TooltipsData = { shows: storageData?.shows || [], time: lastShowTime };
    // Если можем показать фейкдор и ещё не записывали показ из этой сессии - сохраняем показ
    if (!newData.shows?.includes?.(X_PAGE_ID) && isCanShowAiTooltip) {
        newData.shows?.push?.(X_PAGE_ID);
        newData.time = currentTime;

        safetyPersonalLocalStorage.setItem(storageKeyForTooltips, JSON.stringify(newData));
    }

    return isCanShowAiTooltip;
};
